import React from 'react';
import { Grid } from '@mui/material';

import { ModuleSearchField, SearchSelectField, useSettings } from 'app/main/components';
import { type DetailsSectionInfoContentProps } from 'app/main/components/page-layouts';

export default function PeopleDetailsSectionSource(props: DetailsSectionInfoContentProps) {
	const { t } = useSettings();

	return (
		<>
			<Grid size={12}>
				{/* COMPANY */}
				<ModuleSearchField
					name="peop_comp_uid"
					label={t('DETAILS_PEOPLE_FIELD_COMPANY')}
					module="companies"
					uid={props.model.peop_comp_uid}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			<Grid size={12}>
				{/* LEAD CHANNEL */}
				<SearchSelectField
					name="peop_lech_id"
					label={t('DETAILS_PEOPLE_FIELD_LEADCHANNEL')}
					systable="leadchannels"
					value={props.model.peop_lech_id}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			<Grid size={12}>
				{/* ORIGIN MARKETING ACTION */}
				<ModuleSearchField
					name="peop_maac_uid"
					label={t('DETAILS_PEOPLE_FIELD_MARKETINGACTION')}
					module="marketingactions"
					uid={props.model.peop_maac_uid}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
					validations={{
						noDuplicatedCampaigns: (values, value) => {
							return !!values.peop_cmcp_uid && !!value?.maac_uid
								? t('ERROR_TEXT_NO_DUPLICATED_CAMPAIGNS')
								: true;
						}
					}}
				/>
			</Grid>
			<Grid size={12}>
				{/* ORIGIN COMMERCIAL CAMPAIGN */}
				<ModuleSearchField
					name="peop_cmcp_uid"
					label={t('DETAILS_PEOPLE_FIELD_COMMERCIALCAMPAIGN')}
					module="commercialcampaigns"
					uid={props.model.peop_cmcp_uid}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
					validations={{
						noDuplicatedCampaigns: (values, value) => {
							return !!values.peop_maac_uid && !!value?.cmcp_uid
								? t('ERROR_TEXT_NO_DUPLICATED_CAMPAIGNS')
								: true;
						}
					}}
				/>
			</Grid>
			<Grid size={12}>
				{/* BROKER COMPANY */}
				<ModuleSearchField
					name="peop_broker_comp_uid"
					label={t('DETAILS_PEOPLE_FIELD_BROKER_COMPANY')}
					module="companies"
					uid={props.model.peop_broker_comp_uid}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			<Grid size={12}>
				{/* BROKER PERSON */}
				<ModuleSearchField
					name="peop_broker_peop_uid"
					label={t('DETAILS_PEOPLE_FIELD_BROKER_PERSON')}
					module="people"
					uid={props.model.peop_broker_peop_uid}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
		</>
	);
}
